import React from 'react';
import PopularPostPreview from '../PopularPostPreview';
import { popularPosts } from './styles.module.css';

const PopularPosts = ({ posts, hasTitle }) => {
  const { edges } = posts || {};

  return (
    <div className={popularPosts}>
      {edges.map((node) => <PopularPostPreview post={node} />) }
    </div>
  );
};

export default PopularPosts;
